import { categories } from "@/mocks/gossip";
import { scrollToId } from "@/lib/scroll";
import SectionHead from "./SectionHead";

export default function Categories() {
  return (
    <section id="category" className="relative scroll-mt-24 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHead
          kicker="娱乐吃瓜分类"
          title="按你爱的口味，分门别类地吃"
          desc="影视、综艺、乐坛、主播、品牌与行业观察六大方向，覆盖一线新瓜的每一块瓜田。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <article
              key={c.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-stone-200 bg-white transition-colors hover:border-brand-200"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={c.image}
                  alt={c.name + " 吃瓜前线分类"}
                  title={c.name + "分类"}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
                  <h3 className="font-heading text-[19px] font-black text-white">{c.name}</h3>
                  <span className="rounded-full bg-white/85 px-2 py-0.5 text-[11px] font-bold text-brand-700 backdrop-blur">
                    {c.count} 篇
                  </span>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <p className="text-[13px] leading-relaxed text-stone-500">{c.desc}</p>
                <ul className="mt-3 flex flex-col gap-1.5">
                  {c.posts.map((p) => (
                    <li key={p}>
                      <a
                        href="#exclusive"
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToId("exclusive");
                        }}
                        className="flex items-center gap-2 text-[13px] text-stone-600 hover:text-brand-700"
                      >
                        <i className="ri-goblet-line text-[12px] text-brand-400" />
                        {p}
                      </a>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToId("newsletter")}
                  className="mt-auto inline-flex items-center gap-1 self-start whitespace-nowrap pt-3 text-[13px] font-semibold text-brand-600 hover:text-brand-700"
                >
                  看更多{c.name}速递 <i className="ri-arrow-right-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}